export var SELECTED_PLATFORM_STORAGE_KEY = 'mma-mfe__selected-platform';
export var Platform;
(function (Platform) {
    Platform["VISTA"] = "digital-servicing";
    Platform["PEAKS"] = "digital-servicing-pre-login";
})(Platform || (Platform = {}));
//# sourceMappingURL=mma-config.js.map